import React from "react";
import Editor from "@/components/view/Editor";
import { useQuery } from "@/hooks/useQuery";
import {
  formResponsesPathEntry,
  formDefinitionPathEntry,
  useYDoc,
  viewsPathEntry,
} from "@/hooks/useY";
import { FormDefinition, FormResponse, FormView } from "@/types/form";
import {
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  TextField,
} from "@mui/material";
import { useCallback, useState } from "react";

export default function App() {
  const [views, setViews] = useYDoc<FormView[]>([viewsPathEntry], []);
  const [mainForm] = useYDoc<FormDefinition>([formDefinitionPathEntry], {
    titleFieldId: undefined,
    sections: [],
  });

  const [selectedProcessId, setSelectedProcessId] = useState("none");
  const [formResponses] = useYDoc<FormResponse[]>([formResponsesPathEntry], []);

  const { viewId } = useQuery();
  const view = views.find((view) => view.id === viewId)!;

  const setView = useCallback(
    (view: FormView) => {
      const index = views.findIndex((v) => v.id === view.id);
      setViews([...views.slice(0, index), view, ...views.slice(index + 1)]);
    },
    [setViews, views]
  );

  const setContent = useCallback(
    (content: string) => {
      setView({ ...view, content });
    },
    [setView, view]
  );

  const formDefinition =
    selectedProcessId === "none"
      ? mainForm
      : formResponses.find((formResponse) => formResponse.id === selectedProcessId)!.formDefinition;
  const responses =
    formResponses.find((formResponse) => formResponse.id === selectedProcessId)?.responses ??
    [];

  return (
    <>
      <Box sx={{ p: 3, maxWidth: 1207, margin: "0 auto" }}>
        <TextField
          label="View Title"
          value={view.title}
          onChange={(e) => setView({ ...view, title: e.target.value })}
          variant="outlined"
          fullWidth
          sx={{ mb: 2 }}
        />
        <FormControl fullWidth>
          <InputLabel id="form-response-selector-label">Example Process</InputLabel>
          <Select
            labelId="form-response-selector-label"
            id="form-response-selector"
            value={selectedProcessId}
            label="Example Form Response"
            onChange={(e) => setSelectedProcessId(e.target.value as string)}
            sx={{ mb: 2 }}
          >
            <MenuItem value="none">None</MenuItem>
            {formResponses.map((formResponse) => (
              <MenuItem value={formResponse.id} key={formResponse.id}>
                {formResponse.responses.find(
                  (answer) => answer.id === formResponse.formDefinition.titleFieldId
                )?.value ?? "Untitled Process"}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <Editor
          content={view.content}
          setContent={setContent}
          formDefinition={formDefinition}
          responses={responses}
          formResponseId={selectedProcessId}
        />
      </Box>
    </>
  );
}
